/**
 * @typedef {object} PaymentProviderAccountStatus
 * @property {string} accountOwner a network user id (e.g. "meetme:user:12345")
 * @property {object} pay
 * @property {string} pay.provider payment provider (e.g., "paypal")
 * @property {?string} pay.providerDisplay usually an email
 * @property {?string} pay.status
 * @property {?string} pay.providerId id associated with the payment provider
 * @property {object} tax
 * @property {string} tax.provider e.g. "taxbandits"
 * @property {?string} tax.status
 */

// These states are defined in web-payments
export const RegistrationStatus = {
  RegisteredVerified: 'REGISTERED_VERIFIED',
  RegisteredUnverified: 'REGISTERED_UNVERIFIED',
  Unregistered: 'UNREGISTERED',
};

/**
 * Data targets are used to define which element (often modals) should be opened when
 * a user clicks on a given element. This is a Bootstrap concept which allows specifying
 * a "data-target" attribute on an element without having to manually add a JavaScript
 * click handler.
 *
 * @readonly
 * @enum {string}
 */
export const ClaimRewardDataTarget = {
  EmailEntry: '#cashout-email',
  TaxRequirements: '#cashout-tax-requirements',
  Confirmation: '#cashout-confirmation',
  Signup: '#cashout-signup',
  Verify: '#cashout-verify-account',
};

/**
 * All possible tax statuses
 *
 * @readonly
 * @enum {string}
 */
export const ClaimRewardTaxStatus = {
  Pending: 'PENDING',
  Approved: 'APPROVED',
  NotApproved: 'NOT_APPROVED',
};

/**
 * All possible tax form statuses
 *
 * @readonly
 * @enum {string}
 */
export const ClaimRewardTaxFormStatus = {
  NotStarted: 'NOT_STARTED',
  Started: 'STARTED',
  Submitted: 'SUBMITTED',
  Accepted: 'ACCEPTED',
  Rejected: 'REJECTED',
};

/**
 * Possible KYC statuses
 *
 * @readonly
 * @enum {string}
 */
export const ClaimRewardKycStatus = {
  NotApproved: 'NOT_APPROVED',
  Approved: 'APPROVED',
  Pending: 'PENDING',
  Bypass: 'BYPASS',
  Rejected: 'REJECTED',
};
